/**
 * @file MapLoadingSkeleton.tsx
 * @description Loading skeleton for map component
 * @module components/MapLoadingSkeleton
 */

'use client';

import { useTranslations } from 'next-intl';

export default function MapLoadingSkeleton() {
  const t = useTranslations('map');
  return (
    <div className="map-loading-skeleton" style={{
      width: '100%',
      height: '100%',
      minHeight: '500px',
      position: 'relative',
      overflow: 'hidden',
      backgroundColor: '#f0f4f8',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      {/* Animated gradient background */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '200%',
        height: '100%',
        background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
        animation: 'shimmer 2s infinite',
      }}></div>

      {/* Loading content */}
      <div style={{
        position: 'relative',
        zIndex: 1,
        textAlign: 'center',
        padding: '2rem',
      }}>
        {/* Map icon skeleton */}
        <div style={{
          width: '80px',
          height: '80px',
          margin: '0 auto 1.5rem',
          borderRadius: '50%',
          backgroundColor: 'rgba(139, 92, 246, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          animation: 'pulse 1.5s ease-in-out infinite',
        }}>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="rgb(139, 92, 246)" strokeWidth="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
        </div>

        {/* Loading text */}
        <h3 style={{
          fontSize: '1.25rem',
          fontWeight: '600',
          marginBottom: '0.5rem',
          color: '#1f2937',
        }}>
          {t('loading')}
        </h3>

        <p style={{
          fontSize: '0.875rem',
          color: '#6b7280',
          marginBottom: '1.5rem',
        }}>
          {t('preparingMap')}
        </p>

        {/* Loading spinner */}
        <div style={{
          width: '40px',
          height: '40px',
          margin: '0 auto',
          border: '4px solid rgba(139, 92, 246, 0.1)',
          borderTop: '4px solid rgb(139, 92, 246)',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }}></div>
      </div>

      {/* CSS animations */}
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.8;
            transform: scale(1.05);
          }
        }

        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
}
